import { observable, action, flow, set } from 'mobx';

import Stores from 'config/Stores';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Serv from './MemberBirthdayServ';
import { cloneDeep } from 'lodash';

class MemberBirthdayMod {
  @observable birthUserInfo = {
    text: '',
    textCode: '',
    defaultText: '',
    photo: '',
    videoUrl: '',
    defaultVideoUrl: 'https://image.yofogo.com/video/birthday.mp4',
    videoPhotoUrl: '',
    defaultVideoImg: 'https://image.yofogo.com/video/poster.jpg'
  };
  //是否从选择视频页面跳转
  @observable isGoback = false;

  @action
  changeModState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  setItemValue(item, value) {
    set(item, value);
  }

  /**
   * 获取详情
   */
  delInfo = flow(function* (obj) {
    const { params, type } = obj || {};

    try {
      const result = yield Serv.delInfo(params, type);
      if (result && result.data && type === 'get') {
        this.birthUserInfo = result.data || {};
      }
      if (result && result.data && type === 'post_json') {
        const newBirthUserInfo = { ...this.birthUserInfo, ...params };
        this.birthUserInfo = cloneDeep(newBirthUserInfo);
        Toast.info('保存成功！');
      }
      return result.data;
    } catch (error) {}
  });

  /**
   * 推荐文章
   */
  queryHotArtList = flow(function* (id) {
    try {
      const { data } = yield Serv.queryHotArtList({ contentId: id });
      this.hotArtList = data.list;
    } catch (error) {}
  });
}
const memberBirthdayMod = new MemberBirthdayMod();

export default memberBirthdayMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/MemberBirthday/MemberBirthdayMod.js